import React from 'react';
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai';
import TextField from '../text-field';

interface IProps {
  label: string;
  name: string;
}

const PasswordTextField: React.FC<IProps> = ({ label, name }) => {
  const [passwordVisibleSwitch, setPasswordVisibleSwitch] =
    React.useState<boolean>(false);
  const handlePasswordVisible = () =>
    setPasswordVisibleSwitch(!passwordVisibleSwitch);

  return (
    <div className="relative">
      <TextField
        label={label}
        name={name}
        type={`${!passwordVisibleSwitch ? 'password' : 'text'}`}
      />
      <div>
        {!passwordVisibleSwitch ? (
          <AiOutlineEye
            className="absolute top-10 right-4 "
            onClick={handlePasswordVisible}
            size={20}
            color="#4062FF"
          />
        ) : (
          <AiOutlineEyeInvisible
            className="absolute top-10 right-4 "
            onClick={handlePasswordVisible}
            size={20}
            color="#4062FF"
          />
        )}
      </div>
    </div>
  );
};

export default React.memo(PasswordTextField);
